import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, } from 'reactstrap';

import { verificationCodeFields } from '../../shared/models/user';
import QrCode from '../QrCode';
import ModelForm from '../forms/ModelForm';

export default function MultiFactorEnrollModal(props) {
  const { isOpen, onClickClose, totpSecret, totpUri, issuer, accountName, } = props;

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>
        2段階認証の設定
      </ModalHeader>
      <ModalBody>
        <ol className="pl-3">
          <li>
            Google Authenticator などの認証アプリ
            (<a href="https://apps.apple.com/jp/app/google-authenticator/id388497605" target="_blank" rel="noopener noreferrer">iOS</a>
            / <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" rel="noopener noreferrer">Android</a>)
            で以下のQRコードを読み取ってください。
          </li>
          <li>
            アプリに表示された6桁の認証コードを入力してください。
          </li>
        </ol>
        <div className="d-flex justify-content-center">
          <QrCode uri={totpUri} />
        </div>
        <details className="mb-3 small">
          <summary className="text-primary cursor-pointer">QRコードを読み取れない場合</summary>
          <table className="table table-sm mt-2 mb-0">
            <tbody>
              <tr>
                <th className="text-nowrap">サービス名</th>
                <td>{issuer}</td>
              </tr>
              <tr>
                <th className="text-nowrap">アカウント名</th>
                <td>{accountName}</td>
              </tr>
              <tr>
                <th className="text-nowrap">キー</th>
                <td className="text-monospace text-break">{totpSecret.secretKey}</td>
              </tr>
            </tbody>
          </table>
        </details>
        <ModelForm isOpen={isOpen} fields={verificationCodeFields} submitLabel="認証して設定する" onSubmit={props.onSubmit} />
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClickClose}>キャンセル</Button>
      </ModalFooter>
    </Modal>
  );
};
